module.exports = __webpack_public_path__ + "static/renato_candido-ed9bd1f651c4e12bc32281604d14e56e.png";